export class Uuid {
  static newUuid(): string {
    return Array(15)
      .fill(0)
      .map(() => Math.floor(Math.random() * 16).toString(16))
      .join("");
  }
}
